import React from 'react';

import { Description, StyledTooltip, Title } from './styles';

export interface TooltipProps {
    title: string;
    description: string;
}

// TODO: Consider `aria-` attributes
export function Tooltip({ title, description }: TooltipProps) {
    return (
        <StyledTooltip>
            <Title>{title}</Title>
            <Description>{description}</Description>
        </StyledTooltip>
    );
}
